import { createImageApi } from './imageApi';
const api = createImageApi('item-images', 'item');
export function uploadItemImage(data) {
    return api.upload(data);
}
export function getItemImages(levelId) {
    return api.list(levelId);
}
export function getArchivedItemImages(levelId) {
    return api.listArchived(levelId);
}
export function archiveItemImage(id) {
    return api.archive(id);
}
export function restoreItemImage(id) {
    return api.restore(id);
}
export function deleteItemImagePermanent(id) {
    return api.deletePermanent(id);
}
